import Backbone from 'backbone';
import messageTemplate from '../template/coupon-steps.pug';

export interface CouponStepsOptions extends Backbone.ViewOptions<Backbone.Model> {
  steps: string[];
}

export type CouponStepsRuntimeFields = Pick<CouponStepsOptions, 'steps'>;

export default class View extends (Backbone.View as new (options: CouponStepsOptions) => Backbone.View<Backbone.Model>) {
  initialize({
    steps,
  }: CouponStepsOptions) {
    (this as this & CouponStepsRuntimeFields).steps = steps;
  }

  render() {
    this.$el.html(messageTemplate({
      steps: (this as this & CouponStepsRuntimeFields).steps,
    }));
    return this;
  }
}
